import { useRef, useEffect } from "react";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Link2, Image as ImageIcon, Pilcrow } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function RichTextEditor({ value, onChange, testid = "rte" }) {
  const ref = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => onChange(ref.current.innerHTML);
  const cmd = (command, arg = null) => { document.execCommand(command, false, arg); ref.current.focus(); emit(); };
  const block = (tag) => { document.execCommand("formatBlock", false, tag); ref.current.focus(); emit(); };

  const addLink = () => {
    const url = window.prompt("URL del link (https://...)");
    if (url) cmd("createLink", url);
  };

  const onPickImage = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      ref.current.focus();
      document.execCommand("insertHTML", false, `<img src="${r.data.url}" alt="${file.name.replace(/"/g, "")}" />`);
      emit();
    } catch { toast.error("Upload immagine non riuscito"); }
  };

  const Btn = ({ icon: Icon, onClick, label }) => (
    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onClick} title={label}
      className="w-9 h-9 rounded-lg hover:bg-stone flex items-center justify-center text-fir-deep/80 hover:text-fir transition-colors">
      <Icon size={17} />
    </button>
  );

  return (
    <div className="border border-stone rounded-xl overflow-hidden bg-white" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-0.5 border-b border-stone bg-stone/30 p-1.5">
        <Btn icon={Bold} label="Grassetto" onClick={() => cmd("bold")} />
        <Btn icon={Italic} label="Corsivo" onClick={() => cmd("italic")} />
        <span className="w-px h-6 bg-stone mx-1" />
        <Btn icon={Heading2} label="Titolo" onClick={() => block("H2")} />
        <Btn icon={Heading3} label="Sottotitolo" onClick={() => block("H3")} />
        <Btn icon={Pilcrow} label="Paragrafo" onClick={() => block("P")} />
        <span className="w-px h-6 bg-stone mx-1" />
        <Btn icon={List} label="Elenco puntato" onClick={() => cmd("insertUnorderedList")} />
        <Btn icon={ListOrdered} label="Elenco numerato" onClick={() => cmd("insertOrderedList")} />
        <span className="w-px h-6 bg-stone mx-1" />
        <Btn icon={Link2} label="Inserisci link" onClick={addLink} />
        <Btn icon={ImageIcon} label="Inserisci immagine" onClick={() => fileRef.current?.click()} />
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={onPickImage} data-testid="rte-image-input" />
      </div>
      <div ref={ref} contentEditable data-testid="rte-area" onInput={emit} suppressContentEditableWarning
        className="blog-content min-h-[300px] max-h-[55vh] overflow-y-auto p-4 focus:outline-none" />
    </div>
  );
}
